import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    // Load cart from localStorage on init
    const savedCart = localStorage.getItem('StreetMoneyGaming_cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('StreetMoneyGaming_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (mod) => {
    setCartItems(prevItems => {
      const existingItem = prevItems.find(item => item.id === mod.id);
      if (existingItem) {
        // Item already in cart, don't add duplicate
        return prevItems;
      }
      return [...prevItems, { ...mod, quantity: 1 }];
    });
  };

  const removeFromCart = (modId) => {
    setCartItems(prevItems => prevItems.filter(item => item.id !== modId));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getCartCount = () => {
    return cartItems.length;
  };

  const isInCart = (modId) => {
    return cartItems.some(item => item.id === modId);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        getCartTotal,
        getCartCount,
        isInCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
